import React from 'react';
import {
  tags
} from "./response.module.css"

const PreferenceResponse = (props) => (
  <>
    <ul>
    	{props.response}
    </ul>
    <br />
    <h1>Great! We will take a note of that!</h1>
    <ul className={tags}>
    	{props.questions[props.currentQuestion].tags.map((tag) => <li>{tag.toUpperCase()}</li>)}
    </ul>
  </>
)

export default PreferenceResponse